import { LitElement, html, css} from 'https://cdn.jsdelivr.net/gh/lit/dist@2/core/lit-core.min.js';

class ProductGroupDropdown extends LitElement {
    static get properties() {
        return {
            open: { type: Boolean }
        }
    }

    constructor() {
        super();
        this.open = false;
        //find #layout-shift-fix element and remove it
        const layoutShiftFix = this.querySelector('#layout-shift-fix');
        if(layoutShiftFix){
            layoutShiftFix.remove();
        }

    }

    toggle() {
        this.open = !this.open;
    }

    render() {
        return html`
            <slot name="active-product" @click=${this.toggle}></slot>
            <div class="dropdown" ?open=${this.open}>
                <slot></slot>
            </div>
            <div class="dropdown-overlay" @click=${this.toggle}></div>
        `;
    }

    static get styles() {
        return css`
        :host {
            display: block;
            position: relative;        
            margin-bottom:1rem;    
        }

        .dropdown {
            display: none;
            position: fixed;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: #fff;            
            z-index: 2;
            max-height: 300px;
            overflow-y: auto;
        }

        
        .dropdown[open] {
            display: block;
        }

        .dropdown-overlay {
            display: none;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 1;
        }

        .dropdown[open] + .dropdown-overlay {
            display: block;
        }

        .dropdown[open] svg{
            transform: rotate(180deg);
        }
       

        @media screen and (min-width: 768px) {
            .dropdown {
                position: absolute;
                top: 100%;
                bottom: auto;
                margin-top: -1px;
            }

            .dropdown[open] + .dropdown-overlay {
                background-color: transparent;
            }

        }



        `;
    }
}

class ProductGroupProduct extends LitElement {
    static get properties() {
        return {
            name: { type: String },
            url: { type: String },
            activeProduct: { type: Boolean }
        }
    }

    constructor() {
        super();
        this.name = '';
        this.url = '';
        this.activeProduct = false; 
    }

    render() {
        if(this.activeProduct){
            return html`
            <a>
                <slot name="image"></slot>
                <span>${this.name}</span>      
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                    <path d="M7.646 11.854a.5.5 0 0 1-.708 0L1.5 6.207 2.914 4.793 7.5 9.086 12.086 4.793l1.414 1.414-5.646 5.647z"/>
                </svg>
            </a>
            `;

        }else{
            return html`
            <a href="${this.url}">
                <slot name="image"></slot>
                <span>${this.name}</span>      
            </a>
            `;            
        }

        

    }

    static get styles() {
        return css`
        :host {
            display:block!important;
        }

        a {
            display: flex;
            flex-direction: row;
            align-items: center;
            text-decoration: none;
            color: black;
            border: 1px solid black;
            padding: .25rem;
            margin-top:-1px;
            height: 75px;
        }

        :host(:first-child) a {
            margin-top: 0;
        }

        span{
            margin-left:1rem;
        }

        ::slotted(img){
            width: 75px;
            height: 75px;
            aspect-ratio: 1;
            object-fit: cover;
        }

        svg{
            margin-left: auto;
            margin-right: 1rem;
        }
        `;
    }
}

customElements.define('ct-product-group-dropdown', ProductGroupDropdown);
customElements.define('ct-product-group-dropdown-product', ProductGroupProduct);